import { ChangeDetectorRef, Component, EventEmitter, Input, Output } from '@angular/core';
import { faCircle, faEllipsisVertical } from '@fortawesome/free-solid-svg-icons';

import { SinclairCard, SinclairCardFilterOption, SinclairCardFilterOptionType } from './model/sinclair-card-type';
import { SinclairCardsFormService } from './services/sinclair-cards-form.service';

@Component({
    selector: 'app-sinclair-cards',
    templateUrl: './sinclair-cards.component.html'
})
export class SinclairCardsComponent {

    @Input() cards: SinclairCard[] = [];

    @Output() filterChanged = new EventEmitter<void>();
    @Output() filtersClicked = new EventEmitter<SinclairCard>();

    faEllipsisVertical = faEllipsisVertical;
    faCircle = faCircle;

    cardFilerOptionType = SinclairCardFilterOptionType;

    public CARD_FILTERS_NUMBER_OF_HOURS = 'numberHours';

    constructor(
        private readonly changeDetectorReference: ChangeDetectorRef,
        private readonly sinclairCardsFormService: SinclairCardsFormService
    ) { }

    clickFilter(activeFilter: SinclairCardFilterOption, card: SinclairCard) {

        const cardIndex = this.cards.findIndex(c => c.name === card.name);

        if (cardIndex !== -1) {
            if (this.cards[cardIndex].name === this.CARD_FILTERS_NUMBER_OF_HOURS && activeFilter.title === 'statistics.cards.filters.number-hours.custom.label') {
                this.sinclairCardsFormService.openCreationCustomDateSearchForm(card, this.filterChanged, activeFilter.tooltip);
            } else {
                this.cards[cardIndex].subTitle = activeFilter.subTitle;
                this.cards[cardIndex].tooltip = activeFilter.tooltip;
                this.cards[cardIndex].labelState = activeFilter.labelState;
                this.cards[cardIndex].stateClass = activeFilter.stateClass;
                this.cards[cardIndex].title = activeFilter.title;
                this.cards[cardIndex].filters.forEach(filter => {
                    filter.active = filter === activeFilter;
                });

                this.changeDetectorReference.detectChanges();
                this.filterChanged.emit();
            }
        }        

    }

    cardFiltersOpen(card: SinclairCard) {
        this.filtersClicked.emit(card);
    }

}
